import {
    ORDER_CREATE_REQUEST,
    ORDER_CREATE_SUCCESS,
    ORDER_CREATE_FAIL,

    ORDER_CREATE_RESET,

    ORDER_DETAILS_REQUEST,
    ORDER_DETAILS_SUCCESS,
    ORDER_DETAILS_FAIL,

    ORDER_PAY_REQUEST,
    ORDER_PAY_SUCCESS,
    ORDER_PAY_FAIL,
    ORDER_PAY_RESET,

    ORDER_LIST_MY_REQUEST,
    ORDER_LIST_MY_SUCCESS,
    ORDER_LIST_MY_FAIL,
    ORDER_LIST_MY_RESET,

    ORDER_LIST_REQUEST,
    ORDER_LIST_SUCCESS,
    ORDER_LIST_FAIL,

    ORDER_DELIVER_REQUEST,
    ORDER_DELIVER_SUCCESS,
    ORDER_DELIVER_FAIL,
    ORDER_DELIVER_RESET,

    STRIPE_PUBLISHABLE_KEY_REQUEST,
    STRIPE_PUBLISHABLE_KEY_SUCCESS,
    STRIPE_PUBLISHABLE_KEY_FAIL,

    STRIPE_PAYMENT_INTENT_REQUEST,
    STRIPE_PAYMENT_INTENT_SUCCESS,
    STRIPE_PAYMENT_INTENT_FAIL,

    SHIPPING_COST_REQUEST,
    SHIPPING_COST_SUCCESS,
    SHIPPING_COST_FAIL,

    SHIPPING_COUNTRIES_REQUEST,
    SHIPPING_COUNTRIES_SUCCESS,
    SHIPPING_COUNTRIES_FAIL,
} from '../constants/orderConstants'


export const stripePaymentIntentReducer = (state = {}, action) => {
    switch (action.type) {
        case STRIPE_PAYMENT_INTENT_REQUEST:
            return { loading: true };
        case STRIPE_PAYMENT_INTENT_SUCCESS:
            return { loading: false, clientSecret: action.payload.clientSecret };
        case STRIPE_PAYMENT_INTENT_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};


export const stripePublishableKeyReducer = (state = {}, action) => {
    switch (action.type) {
        case STRIPE_PUBLISHABLE_KEY_REQUEST:
            return { loading: true };
        case STRIPE_PUBLISHABLE_KEY_SUCCESS:
            return { loading: false, publishableKey: action.payload.publishableKey };
        case STRIPE_PUBLISHABLE_KEY_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};


export const orderCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case ORDER_CREATE_REQUEST:
            return {
                loading: true
            }

        case ORDER_CREATE_SUCCESS:
            return {
                loading: false,
                success: true,
                order: action.payload
            }

        case ORDER_CREATE_FAIL:
            return {
                loading: false,
                error: action.payload
            }

        case ORDER_CREATE_RESET:
            return {}


        default:
            return state
    }
}


export const orderDetailsReducer = (state = { loading: true, orderItems: [], shippingAddress: {} }, action) => {
    switch (action.type) {
        case ORDER_DETAILS_REQUEST:
            return {
                ...state,
                loading: true
            }

        case ORDER_DETAILS_SUCCESS:
            return {
                loading: false,
                order: action.payload
            }

        case ORDER_DETAILS_FAIL:
            return {
                loading: false,
                error: action.payload
            }


        default:
            return state
    }
}


export const orderPayReducer = (state = {}, action) => {
    switch (action.type) {
        case ORDER_PAY_REQUEST:
            return {
                loading: true
            }

        case ORDER_PAY_SUCCESS:
            return {
                loading: false,
                success: true
            }

        case ORDER_PAY_FAIL:
            return {
                loading: false,
                error: action.payload
            }

        case ORDER_PAY_RESET:
            return {}

        default:
            return state
    }
}


export const orderDeliverReducer = (state = {}, action) => {
    switch (action.type) {
        case ORDER_DELIVER_REQUEST:
            return {
                loading: true
            }

        case ORDER_DELIVER_SUCCESS:
            return {
                loading: false,
                success: true
            }

        case ORDER_DELIVER_FAIL:
            return {
                loading: false,
                error: action.payload
            }

        case ORDER_DELIVER_RESET:
            return {}

        default:
            return state
    }
}


export const orderListMyReducer = (state = { orders: [] }, action) => {
    switch (action.type) {
        case ORDER_LIST_MY_REQUEST:
            return {
                loading: true
            }

        case ORDER_LIST_MY_SUCCESS:
            return {
                loading: false,
                orders: action.payload
            }

        case ORDER_LIST_MY_FAIL:
            return {
                loading: false,
                error: action.payload
            }

        case ORDER_LIST_MY_RESET:
            return {
                orders: []
            }

        default:
            return state
    }
}



export const orderListReducer = (state = { orders: [] }, action) => {
    switch (action.type) {
        case ORDER_LIST_REQUEST:
            return {
                loading: true
            }

        case ORDER_LIST_SUCCESS:
            return {
                loading: false,
                orders: action.payload
            }

        case ORDER_LIST_FAIL:
            return {
                loading: false,
                error: action.payload
            }
        default:
            return state
    }
}

export const shippingCostReducer = (state = { shippingRates: [] }, action) => {
    switch (action.type) {
        case SHIPPING_COST_REQUEST:
            return { loading: true }

        case SHIPPING_COST_SUCCESS:
            return { loading: false, shippingRates: action.payload }

        case SHIPPING_COST_FAIL:
            return { loading: false, error: action.payload }

        default:
            return state
    }
}

export const shippingCountriesReducer = (state = { countries: [] }, action) => {
    switch (action.type) {
        case SHIPPING_COUNTRIES_REQUEST:
            return { loading: true }

        case SHIPPING_COUNTRIES_SUCCESS:
            return { loading: false, countries: action.payload }

        case SHIPPING_COUNTRIES_FAIL:
            return { loading: false, error: action.payload }

        default:
            return state
    }
}